module.exports = __webpack_public_path__ + "static/media/logos_50h_hkpu.1d7bbea6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_50h_hkpu.jpg
// module id = 228
// module chunks = 0